import { render, staticRenderFns } from "./PphCustomer.vue?vue&type=template&id=5c1f6c18&scoped=true&"
import script from "./PphCustomer.vue?vue&type=script&lang=ts&"
export * from "./PphCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f6c18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c1f6c18')) {
      api.createRecord('5c1f6c18', component.options)
    } else {
      api.reload('5c1f6c18', component.options)
    }
    module.hot.accept("./PphCustomer.vue?vue&type=template&id=5c1f6c18&scoped=true&", function () {
      api.rerender('5c1f6c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-receivables/reports/PphCustomer.vue"
export default component.exports